import { axiosInstance, parseResponse, TENANT_API_URL } from "..";

export const SETTINGS_URL = `${TENANT_API_URL}/settings`;

export const getTenantSettings = async () => {
  try {
    const response = await axiosInstance.get(SETTINGS_URL);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updateTenantSettings = async (data) => {
  try {
    const response = await axiosInstance.put(SETTINGS_URL, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
